const Final = props => {

    const state = props.state;

    return(
        <>
            <div className="mensaje-final mb-2 text-center pb-2">
                <h6>Gracias por finalizar tu Solicitud de Actividad! <br /> Te contactaremos a la brevedad.</h6>
            </div>
        </>
    )
}


export default Final;